import {useTranslation} from 'react-i18next';
import {Outlet} from 'react-router-dom';
import {Stack} from '@mui/material';
import React, {useEffect, useState} from 'react';
import {useObservable} from '@ngneat/react-rxjs';
import COLUMN_TYPES from '@utils/table/columnTypes.table';
import {GridValueGetterParams} from '@mui/x-data-grid-pro';
import {User} from '@store/settings/users';
import NewTableComponent from '@components/table/NewTable.component';
import {supplierDetailsQuery} from '@store/suppliers/details';

const SupplierDetailsUsersTab = () => {

  const {t} = useTranslation();
  const [{headOffice}] = useObservable(supplierDetailsQuery.supplierDetails$);
  const [users, setUsers] = useState<any[]>();

  useEffect(() => {
    if (headOffice && headOffice.users) {
      setUsers(headOffice.users);
    }
  }, [headOffice]);

  return (
    <>
      <Stack flex={1} mt="10px" spacing={2}>
        <NewTableComponent
          loading={false}
          columns={[
            COLUMN_TYPES.TEXT({
              field: 'lastName',
              label: t('settings.users.table.name'),
              valueGetter: (params: GridValueGetterParams<any, User>) => `${params.row.name ? params.row.name : ''} ${params.row.surName ? params.row.surName : ''}`,
              fullWidth: true,
              minWidth: 100,
              maxWidth: 150,
            }),

            COLUMN_TYPES.TEXT({
              field: 'email',
              label: t('settings.users.table.email'),
              fullWidth: true,
              minWidth: 300
            }),
          ]}
          disablePagination
          disableRowSelection
          data={users}
        />
      </Stack>
      <Outlet/>
    </>
  );
};

export default SupplierDetailsUsersTab;
